import { USERS_UPDATE, USERS_LOADING } from "../actions/types";
import { TestAccount, UserDetails, UserProfile } from "../api/users.interface";

export interface UsersState {
    loadingUsers?: boolean;
    loadingTestAccounts?: boolean;
    searchItem?: UserDetails;
    user?: UserProfile;
    testAccounts?: TestAccount[];
}

const InitialState: UsersState = {
    loadingUsers: false,
    loadingTestAccounts: false,
    testAccounts: [],
};

export const UsersReducer = (state: UsersState = InitialState, action: any) => {
    switch (action.type) {
        case USERS_LOADING:
            return {
                ...state,
                loadingUsers: action.payload,
            };
        case USERS_UPDATE:
            return {
                ...state,
                ...action.payload,
            };
    }
    return state;
}

export default UsersReducer;
